type TdsModalWarning = {
  handleOK(): void
  children: React.ReactNode
  label: string
}

const TdsModalWarning = ({ handleOK, children, label }: TdsModalWarning) => (
  <div
    role="dialog"
    data-backdrop-close="false"
    className="tds-modal tds-modal__dialog--medium"
    data-do-not-move="true"
    id="warningAuto-modal"
  >
    <div role="main" className="tds-modal__dialog-container" aria-label={label}
      aria-describedby="warning-modal-description-md">
      <div className="tds-modal__dialog-body">
        <div className="tds-modal__dialog-body-content" id="warning-modal-description-md">
            {children}
        </div>
      </div>
      <div className="tds-modal__dialog-footer">
        <div className="tds-modal__dialog-button-container">
          <div className="tds-modal__dialog-button-layout">
            <button
              className="tds-button--primary tds-button--small"
              onClick={handleOK}
              data-dismiss="modal"
            >
              OK
            </button>
          </div>
        </div>
      </div>
      <button
        className="tds-modal__dismiss"
        aria-label="Dismiss dialog"
        onClick={handleOK}
        data-dismiss="modal"
        type="button"
      >
        <svg focusable="false">
          <use xlinkHref="/claimuploadcenter/icons/symbol-sprites.svg#x-1-12" />
        </svg>
      </button>
    </div>
  </div>
)

export { TdsModalWarning }
